import React from 'react'

import { Typography } from '@smooth-ui/core-em'
import { Box, Button, Space } from 'UILibrary'
import { css } from 'react-emotion'

const checkEmailDiv = css({
  padding: '15px',
  display: 'block',
})
const CheckEmail = props => {
  return (
    <span className={checkEmailDiv}>
      <Typography variant="h3">Check your email</Typography>
      <Space size="xl" />
      <Box>
        <Typography variant="body">We've sent an email to reset your password. Click the link in the email to reset your password.</Typography>
      </Box>
      <Space size="l" />
      <Box>
        <Typography variant="body">If you don't see the email, check other places it might be, such as your junk, spam, or other folders.</Typography>
      </Box>
      <Space size="xl" />
      <Button form success onClick={() => props.history.push({ pathname: '/', search: `?signin=true` })}>
        BACK TO LOGIN
      </Button>
    </span>
  )
}

export default CheckEmail



// WEBPACK FOOTER //
// ./src/features/authentication/components/CheckEmail.js